import { AttachmentTypeEnum } from "@models/enums/attachment-type-enum";
import { AddressFieldEnum } from "@models/portal/validator/enums/address-field-enum";
import { UserBasicDataEnum } from "@models/portal/validator/enums/user-field-enum";

type UserBasicDataEnumFieldReference = {
  [key in UserBasicDataEnum]: string;
}
type UserAddressEnumFieldReference = {
  [key in AddressFieldEnum]: string;
}

export const userBasicDataFieldReference: UserBasicDataEnumFieldReference = {
  // NOME: 'usuTxNome',
  CODIGO_INEP: 'usuTxCodigoInep',
  DATA_NASCIMENTO: 'usuDtNascimento',
  SEXO: 'usuTxSexo',
  LADO_DOMINANTE: 'usuTxLadoDominante',
  TIPO_SANGUINEO: 'usuTxTipoSanguineo',
  ALTURA: 'usuNrAltura',
  PESO: 'usuNrPeso',
  AUXILIO_BRASIL: 'usuBlAuxilioBrasil',
} as const;

export const userAddressFieldReference: UserAddressEnumFieldReference = {
  CEP: 'logTxCep',
  LOGRADOURO: 'logTxLogradouro',
  NUMERO: 'logNrNumero',
  COMPLEMENTO: 'logTxComplemento',
  BAIRRO: 'logTxBairro',
  // CIDADE: 'cidNrId',
} as const;

